<div class="kr-mass-pay-out-details__header" data-testid="mass_pay_out_header">
  <h4
    class="kr-mass-pay-out-details__header-text"
    data-testid="mass_pay_out_header_text">
    {{ header }}
  </h4>

  <button
    class="kr-mass-pay-out-details__header-btn-close"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    [onlyIcon]="true"
    (click)="close()"
    data-testid="mass_pay_out_close_btn">
    <fu-icon
      iconName="close-square"
      data-testid="mass_pay_out_close_icon"></fu-icon>
  </button>
</div>

<div
  class="kr-mass-pay-out-details__body"
  [ngClass]="withRiskScoreClass"
  data-testid="mass_pay_out_body">
  @if (hasRiskScoreLogic() && !executed()) {
    <div
      class="kr-mass-pay-out-details__header-actions"
      data-testid="mass_pay_out_header_actions">
      <button
        type="button"
        fuButton
        size="s"
        uiType="secondary"
        (click)="downloadCsv()"
        data-testid="mass_pay_out_download_csv_btn">
        <fu-icon
          iconName="document"
          size="16"
          data-testid="mass_pay_out_download_csv_icon" />
        {{ downloadCsvBtnText }}
      </button>
    </div>

    <div
      class="kr-mass-pay-out-details__filters"
      data-testid="mass_pay_out_filters">
      <fu-multi-select
        [formControl]="filtersForm.controls.score"
        [items]="payOutOptions"
        [label]="'massPayOutDetails.column.filters.score.label' | translate"
        [placeholder]="
          'massPayOutDetails.column.filters.score.placeholder' | translate
        "
        data-testid="mass_pay_out_score_filter" />

      <button
        class="fu-form-btn apply-filters-btn"
        type="button"
        fuButton
        size="m"
        uiType="secondary"
        (click)="applyFilters()"
        [disabled]="!filtersForm.touched"
        translate="massWalletScreenResult.filters.apply.btn"
        data-testid="mass_pay_out_apply_filters_btn"></button>
    </div>
  }

  @if (!executed() && false) {
    <div class="kr-mass-pay-out-details__balances">
      <div class="kr-details kr-details_row">
        <label class="kr-details__label">
          {{ 'massPayOutDetails.label.availableNetworkBalance' | translate }}
          {{ networkCoinName() }}:
        </label>

        <span
          class="kr-details__value"
          data-testid="mass_pay_out_network_balance"
          [title]="
            massPayOut()?.networkBalance | balanceFormat: networkCoinName()
          ">
          {{ massPayOut()?.networkBalance | balanceFormat: networkCoinName() }}
        </span>
      </div>
      <div class="kr-details kr-details_row">
        <label class="kr-details__label">
          {{ 'massPayOutDetails.label.availableBalance' | translate }}
          {{ wallet().coin.symbol }}:
        </label>

        <span
          class="kr-details__value"
          data-testid="mass_pay_out_balance_available"
          [title]="
            massPayOut()?.balanceAvailable | balanceFormat: wallet().coin.symbol
          ">
          {{
            massPayOut()?.balanceAvailable | balanceFormat: wallet().coin.symbol
          }}
        </span>
      </div>
    </div>
  }

  <div
    class="kr-mass-pay-out-details__totals"
    data-testid="mass_pay_out_totals">
    <h5
      class="kr-mass-pay-out-details__totals-header"
      [translate]="
        executed()
          ? 'massPayOutDetails.statusHeader'
          : 'massPayOutDetails.detailsHeader'
      "
      data-testid="mass_pay_out_totals_header"></h5>

    @if (executed()) {
      <div class="kr-details kr-details_col">
        <div class="kr-details kr-details_row">
          <label
            class="kr-details__label"
            translate="massPayOutDetails.label.totalTransactions">
          </label>

          <span
            class="kr-details__value"
            data-testid="mass_pay_out_total_transactions">
            {{ totalExecutedCount() }}
          </span>
        </div>
      </div>

      <div class="kr-details kr-details_col">
        <div class="kr-details kr-details_row">
          <label
            class="kr-details__label kr-details_danger"
            translate="massPayOutDetails.label.failedTransactions">
          </label>

          <span
            class="kr-details__value"
            data-testid="mass_pay_out_failed_transactions">
            {{ totalFailed() }}
          </span>
        </div>
      </div>
    } @else {
      <div class="kr-details kr-details_col">
        <div class="kr-details kr-details_row">
          <label
            class="kr-details__label"
            translate="massPayOutDetails.label.totalTransactions">
          </label>

          <span
            class="kr-details__value"
            data-testid="mass_pay_out_total_transactions">
            {{ filteredTotalCount() || 0 }}
          </span>
        </div>
      </div>

      <div class="kr-details kr-details_col">
        <div class="kr-details kr-details_row">
          <label class="kr-details__label">
            {{ 'massPayOutDetails.label.availableNetworkBalance' | translate }}
            {{ networkCoinName() }}:
          </label>

          <span
            class="kr-details__value"
            [title]="networkBalance() | balanceFormat: networkCoinName()"
            data-testid="mass_pay_out_available_network_balance">
            {{ networkBalance() | balanceFormat: networkCoinName() }}
          </span>
        </div>

        <div class="kr-details kr-details_row">
          <label class="kr-details__label">
            <label class="kr-details__label">
              {{ 'massPayOutDetails.label.totalFee' | translate }}
              {{ networkCoinName() }}:
            </label>
          </label>

          <span
            class="kr-details__value"
            [title]="
              filteredMassPayOut()?.totalFee | balanceFormat: networkCoinName()
            "
            data-testid="mass_pay_out_total_fee">
            {{
              filteredMassPayOut()?.totalFee | balanceFormat: networkCoinName()
            }}
          </span>
        </div>
      </div>

      <div class="kr-details kr-details_col kr-details_last-col">
        <div class="kr-details kr-details_row">
          <label class="kr-details__label">
            {{ 'massPayOutDetails.label.availableBalance' | translate }}
            {{ wallet().coin.symbol }}:
          </label>

          <span
            class="kr-details__value"
            [title]="
              this.wallet().balanceAvailable
                | balanceFormat: wallet().coin.symbol
            "
            data-testid="mass_pay_out_available_balance">
            {{
              this.wallet().balanceAvailable
                | balanceFormat: wallet().coin.symbol
            }}
          </span>
        </div>

        <div class="kr-details kr-details_row">
          <label class="kr-details__label">
            {{ 'massPayOutDetails.label.totalAmount' | translate }}
            {{ wallet().coin.symbol }}:
          </label>

          <span
            class="kr-details__value"
            [title]="
              filteredMassPayOut().totalAmount
                | balanceFormat: wallet().coin.symbol
            "
            data-testid="mass_pay_out_total_amount">
            {{
              filteredMassPayOut().totalAmount
                | balanceFormat: wallet().coin.symbol
            }}
          </span>
        </div>
      </div>
    }
  </div>

  @if (filteredMassPayOut()?.massPayOut?.length && !executed()) {
    <div
      class="kr-mass-pay-out-details__table"
      data-testid="mass_pay_out_table">
      <ul
        class="kr-table__header kr-mass-pay-out-details__table-header"
        [ngClass]="{ score: hasRiskScoreLogic() }"
        data-testid="mass_pay_out_table_header">
        <li class="kr-table__column" data-testid="mass_pay_out_header_index">
          #
        </li>
        @for (name of columnNames; track name) {
          <li
            class="kr-table__column"
            [translate]="'massPayOutDetails.column.' + name"
            [attr.data-testid]="'mass_pay_out_header_' + name"></li>
        }
      </ul>

      <ul class="kr-table__body" data-testid="mass_pay_out_table_body">
        @for (item of filteredMassPayOut().massPayOut; track $index) {
          <li
            class="kr-table__row"
            krMassPayOutItem
            [isCryptoBanco]="isCryptoBanco()"
            [item]="item"
            [wallet]="this.wallet()"
            [num]="$index + 1"
            [withStatus]="executed()"
            [withRiskScore]="hasRiskScoreLogic()"
            [attr.data-testid]="'mass_pay_out_row_' + ($index + 1)"></li>
        }
      </ul>
    </div>
  } @else if (massPayOut().massPayOut?.length && executed()) {
    <div
      class="kr-mass-pay-out-details__table"
      data-testid="mass_pay_out_table">
      <ul
        class="kr-table__header kr-mass-pay-out-details__table-header"
        [ngClass]="{ score: hasRiskScoreLogic() }"
        data-testid="mass_pay_out_table_header">
        <li class="kr-table__column" data-testid="mass_pay_out_header_index">
          #
        </li>
        @for (name of columnNames; track name) {
          <li
            class="kr-table__column"
            [translate]="'massPayOutDetails.column.' + name"
            [attr.data-testid]="'mass_pay_out_header_' + name"></li>
        }
      </ul>

      <ul class="kr-table__body" data-testid="mass_pay_out_table_body">
        @for (item of massPayOut().massPayOut; track $index) {
          <li
            class="kr-table__row"
            krMassPayOutItem
            [isCryptoBanco]="isCryptoBanco()"
            [item]="item"
            [wallet]="this.wallet()"
            [num]="$index + 1"
            [withStatus]="true"
            [withRiskScore]="hasRiskScoreLogic()"
            [attr.data-testid]="'mass_pay_out_row_' + ($index + 1)"></li>
        }
      </ul>
    </div>
  } @else {
    <fu-empty
      iconName="wallet"
      titleKey="transactions.empty.title"
      secondaryBtnLink
      data-testid="mass_pay_out_empty">
    </fu-empty>
  }
  @if (!executed()) {
    <kr-warning-save-balance
      [warningKey]="'errors.notEnoughAmountToPay'"
      [amount]="filteredMassPayOut().totalAmount"
      [balance]="massPayOut().balanceAvailable"
      class="margin-right"
      data-testid="mass_pay_out_warning_total_amount" />

    <kr-warning-save-balance
      [warningKey]="'errors.notEnoughFundsToPay'"
      [amount]="filteredMassPayOut().totalFee"
      [balance]="networkBalance()"
      class="margin-right"
      data-testid="mass_pay_out_warning_total_fee" />
  }
  <div class="kr-actions" data-testid="mass_pay_out_actions">
    <button
      type="button"
      fuButton
      size="m"
      uiType="secondary"
      (click)="close()"
      [translate]="
        executed()
          ? 'massPayOutDetails.btn.close'
          : 'massPayOutDetails.btn.back'
      "
      data-testid="mass_pay_out_back_close_btn"></button>

    @if (!executed()) {
      <button
        type="button"
        fuButton
        size="m"
        uiType="primary"
        [disabled]="isExecuteDisabled()"
        (click)="execute()"
        translate="massPayOutDetails.btn.execute"
        data-testid="mass_pay_out_execute_btn"></button>
    }
  </div>
</div>

<ng-template #failedTpl>
  <fu-icon
    iconName="failed"
    size="64"
    data-testid="mass_pay_out_failed_icon"></fu-icon>

  <h5
    class="kr-mass-pay-out-details__message"
    translate="massPayOutDetails.failed.message"
    data-testid="mass_pay_out_failed_message"></h5>

  <div
    class="kr-details kr-details_center"
    data-testid="mass_pay_out_failed_container">
    <label
      class="kr-details__label"
      translate="massPayOutDetails.failed.label.error">
    </label>

    <span
      class="kr-details__value kr-details_danger"
      data-testid="mass_pay_out_failed_error">
      {{ errMessage() }}
    </span>
  </div>
</ng-template>
